Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var Img = function Img(props) {
  var opacity = props.opacity,
    onLoad = props.onLoad,
    transitionDelay = props.transitionDelay,
    otherProps = _objectWithoutProperties(props, ['opacity', 'onLoad', 'transitionDelay']);
  return _react2['default'].createElement('img', _extends({}, otherProps, {
    onLoad: onLoad,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      transition: 'opacity 0.5s',
      transitionDelay: transitionDelay,
      opacity: opacity,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center'
    }
  }));
};
Img.defaultProps = {
  transitionDelay: '',
  onLoad: null
};
Img.propTypes = {
  opacity: _propTypes2['default'].oneOf([0, 1]).isRequired,
  transitionDelay: _propTypes2['default'].string,
  onLoad: _propTypes2['default'].func
};
exports['default'] = Img;